import {Component, HostListener, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {first} from "rxjs/operators";
import {AccountService, UserService} from "../../services";
import {User} from "../../models";
import {VoucherTemplate} from "../../models/voucherTemplate";


@Component({
    selector: 'second-time-confirmation-dialog',
    templateUrl: './secondTimeConfirmation.component.html',
    styleUrls: ['./secondTimeConfirmation.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class SecondTimeConfirmationDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    codeScanner = [];
    loading: boolean = false;
    lastKeyup: any;
    allowConfirm: boolean = false;
    confirmingUser: User;
    voucherTemplate: VoucherTemplate;
    newVoucherTemplate: VoucherTemplate;
    addMode: boolean;
    differentUserRequired: boolean = false;
    scanningInProgress: boolean = false;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<SecondTimeConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private userService: UserService,
        private accountService: AccountService,
    ) {
        this.translationLoader.loadTranslations(polish);
        this.addMode = _data.addMode;
        this.voucherTemplate = _data.voucherTemplate;
        this.newVoucherTemplate = _data.newVoucherTemplate;

        // console.log(this.voucherTemplate);
        // console.log(this.newVoucherTemplate);
        //
        // let diff = Object.keys(this.newVoucherTemplate).reduce((diff, key) => {
        //     if (this.voucherTemplate[key] === this.newVoucherTemplate[key]) return diff
        //     return {
        //         ...diff,
        //         [key]: this.newVoucherTemplate[key]
        //     }
        // }, {})
        //
        // console.log(diff);
    }

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.scanningInProgress = true;
        if (event.key != 'Enter' && event.key != ' ') {

            if (typeof this.lastKeyup !== "undefined" && ((new Date()).getTime() - this.lastKeyup) > 250) {
                this.codeScanner = [];
            }

            this.codeScanner.push(event.key);
        } else if (event.key == 'Enter' && this.codeScanner.length > 4) {
            this.loading = true;


            this.userService.getByCardNumber(this.codeScanner.join('')).pipe(first())
                        .subscribe(
                            data => {
                                this.loading = false;

                                if (this.accountService.userValue.email !== data.email) {
                                    this.allowConfirm = true;
                                    this.confirmingUser = data;
                                    this.differentUserRequired = false;
                                } else {
                                    this.allowConfirm = false;
                                    this.differentUserRequired = true;
                                }

                                this.scanningInProgress = false;
                            },
                            error => {
                                this.loading = false;
                                if (error == 'User not found.') {

                                }
                                this.scanningInProgress = false;
                            });
            this.codeScanner = [];
        }
    }

    closeConfirmation(event: any) {
        if(event.Key && event.Key==='Enter') {
            return;
        }
        this.matDialogRef.close();
    }

}
